<template>
  <div
    id="properties_filter"
    :class="[
      'band py-lg-5px w-100 z-i-50 z-i-lg-50 tw-bg-white',
      enablePropertyTypeFilters ? 'lg:tw-bg-[#FFFFFF]' : 'lg:tw-bg-gray-50',
      hideWrapperBorder ? 'tw-border-b-0' : 'tw-border-b tw-border-white',
    ]"
  >
    <div
      id="filters_panel"
      :class="[
        'px-0',
        enablePropertyTypeFilters ? '' : 'wrapper',
        enablePropertyTypeFilters ? 'lg:tw-bg-[#FFFFFF]' : 'lg:tw-bg-gray-50',
      ]"
    >
      <PropertiesSearchDesktopFiltersV2
        v-if="!enableHousemateGroups"
        v-bind="propsForV2"
        :title-results-count="titleResultsCount"
        v-on="$listeners"
      />
      <PropertiesSearchDesktopFiltersV3
        v-if="enableHousemateGroups"
        v-bind="$props"
        :title-results-count="titleResultsCount"
        v-on="$listeners"
      />
    </div>
  </div>
</template>

<script>
import PropertiesSearchDesktopFiltersV2 from './PropertiesSearchDesktopFiltersV2.vue';
import PropertiesSearchDesktopFiltersV3 from './PropertiesSearchDesktopFiltersV3.vue';

export default {
  components: {
    PropertiesSearchDesktopFiltersV2,
    PropertiesSearchDesktopFiltersV3,
  },
  props: {
    shortlistModeActive: {
      default: false,
      type: Boolean,
    },
    enablePrivateHallsFilter: {
      default: false,
      type: Boolean,
    },
    enableMarketplaceGridSplitMaps: {
      default: false,
      type: Boolean,
    },
    enableSpareRoomFunctionality: {
      default: false,
      type: Boolean,
    },
    enablePropertyTypeFilters: {
      default: false,
      type: Boolean,
    },
    enableLocalFilterCounts: {
      default: false,
      type: Boolean,
    },
    enableStudentEnquiriesCta: {
      type: Boolean,
      default: false,
    },
    areas: {
      default: function () {
        return [];
      },
      type: Array,
    },
    cities: {
      default: function () {
        return [];
      },
      type: Array,
    },
    currentCitySlug: {
      default: null,
      type: String,
    },
    currentLandlord: {
      default: null,
      type: [Object, String],
    },
    currentUniversitySlug: {
      default: null,
      type: String,
    },
    currentAreaSlug: {
      default: null,
      type: String,
    },
    currentBedrooms: {
      default: null,
      type: [Number, String],
    },
    currentBathrooms: {
      default: null,
      type: [Number, String],
    },
    currentType: {
      default: null,
      type: [String, Array],
    },
    currentMaxPrice: {
      default: null,
      type: [Number, String],
    },
    currentMinPrice: {
      default: null,
      type: [Number, String],
    },
    currentEnquiredProperties: {
      default: false,
      type: Boolean,
    },
    maxCheapestRoomPrice: {
      default: null,
      type: [Number, String],
    },
    maxPriceSelected: {
      default: false,
      type: Boolean,
    },
    minCheapestRoomPrice: {
      default: null,
      type: [Number, String],
    },
    landlordQuery: {
      default: null,
      type: [Number, String],
    },
    propertyCount: {
      default: 0,
      type: Number,
    },
    resultsCountLoading: {
      default: false,
      type: Boolean,
    },
    reloading: {
      default: false,
      type: Boolean,
    },
    rooms: {
      default: function () {
        return [];
      },
      type: Array,
    },
    types: {
      default: function () {
        return [];
      },
      type: Array,
    },
    universities: {
      default: function () {
        return [];
      },
      type: Array,
    },
    titleResultsCount: {
      default: '',
      type: String,
    },
    useExactRoomCounts: {
      type: Boolean,
      default: false,
    },
    hasEnquiredProperties: {
      type: Boolean,
      default: false,
    },
    enableHousemateGroups: {
      default: null,
      type: Boolean,
    },
  },
  computed: {
    hideWrapperBorder() {
      return this.enablePropertyTypeFilters;
    },
    propsForV2() {
      // V2 is used as the control for A/B testing; don't pass through
      // experimental props that would alter its UI.
      // eslint-disable-next-line no-unused-vars
      const { resultsCountLoading, ...rest } = this.$props;
      return rest;
    },
  },
};
</script>
